import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import { Timesheet_APIs } from "./Timesheet_API";
import { AlertPopups } from "../../components/AlertPopups";
import { UserConsumer } from "../../UserContext";
import moment from "moment";
let token = null;
class Comment extends Component {
	constructor(props) {
		super(props);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.state = {
			show: false,
			comment: "",
			project: "",
			date: new Date().toJSON(),
		};

		this.handleChange = this.handleChange.bind(this);
		this.populateData = this.props.data[6].bind(this);
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.data[2] !== this.state.comment) {
			this.setState({ comment: nextProps.data[2] });
		}
	}

	handleChange = (event) => {
		this.setState({
			comment: event.target.value,
		});
	};

	handleSubmit = async () => {
		let data = {
			taskType: this.props.data[1],
			taskId: this.props.data[0],
			comment: this.state.comment,
			commentDate: this.props.data[3],
		};
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		await axios
			.post(`${Timesheet_APIs.AddComment_API}`, data, {
				headers: headers,
			})
			.then(function (response) {
				if (response.status === 200) {
					AlertPopups.successAlert.fire({
						text: "Comment saved",
					});
				}
			});
	};
	handleSave = async () => {
		await this.handleSubmit();
		await this.props.data[6]();
		this.handleClose();
	};
	handleShow() {
		this.setState({ show: true });
	}
	handleClose() {
		this.setState({ show: false });
	}

	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;
					return (
						<div>
							<Modal
								show={this.state.show}
								onHide={this.handleClose}
								aria-labelledby="contained-modal-title-vcenter"
								centered
								dialogClassName="modal-50w"
								className="addComments"
							>
								<Modal.Header
									closeButton
									className="pb-0 pr-4 pt-1 border-0"
								/>
								<Modal.Body closeButton>
									<div className="pr-3">
										<div className="row text-center">
											<div className="col-lg-8 col-md-8 col-sm-12 font-weight-light mb-2 text-left">
												Project Name
												<div className="d-inline font-weight-bold han ml-2 projectName px-2 py-1">
													{this.props.data[4]}
												</div>
											</div>

											<div className="col-lg-4 col-md-4 col-sm-6 d-flex date">
												<label className="font-weight-light">
													Date:
												</label>
												<span className="ml-3">
													{moment(
														this.props.data[3]
													).format("ddd DD MMM")}
												</span>
											</div>
										</div>
									</div>

									<div className="mb-2 mt-3 font-weight-light">
										Add Comment
									</div>
									<div className="row">
										<div className="col-lg-12 col-md-12 col-sm-12 h-auto">
											<textarea
												id="comment"
												className="comment"
												onChange={this.handleChange}
												maxLength="200"
												disabled={
													moment(
														this.props.data[3]
													) >= moment() ||
													this.props.data[5].trim() ===
														"Submitted" ||
													this.props.data[5].trim() ===
														"Approved"
												}
											>
												{this.props.data[2]}
											</textarea>
										</div>
									</div>
									<div className="row saveDiv">
										<Button
											disabled={
												moment(this.props.data[3]) >=
													moment() ||
												this.props.data[5].trim() ===
													"Submitted" ||
												this.props.data[5].trim() ===
													"Approved"
											}
											className="save"
											onClick={() => {
												this.handleSave();
											}}
										>
											Save
										</Button>
									</div>
								</Modal.Body>
							</Modal>
						</div>
					);
				}}
			</UserConsumer>
		);
	}
}
export default Comment;
